import React, { useCallback } from 'react'
import { PayPalScriptProvider, PayPalButtons, FUNDING } from '@paypal/react-paypal-js'

import { PAYPAL_IDS } from '../../utils/constants'

const PayPal = ({ name, email, onSuccess, product, amount, validation }) => {
  const createOrder = useCallback(
    (data, actions) => {
      return actions.order
        .create({
          purchase_units: [
            {
              amount: {
                value: amount
              }
            }
          ],
          application_context: {
            shipping_preference: 'NO_SHIPPING'
          }
        })
        .then(orderID => {
          return orderID
        })
    },
    [amount]
  )

  const handleOnApprove = (data, actions) => {
    actions.order.capture().then((captureData) => {
      onSuccess('paypal', captureData)
    })
  }

  // options={{ 'client-id': PAYPAL.sandbox }}
  return (
    <PayPalScriptProvider options={{ 'client-id': PAYPAL_IDS.production }}>
      <PayPalButtons
        createOrder={createOrder}
        onApprove={handleOnApprove}
        forceReRender={[amount]}
        fundingSource={FUNDING.PAYPAL}
      />
    </PayPalScriptProvider>
  )
}

export default PayPal
